import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import partnersFields from '../../../fields/partnersFields';

export const columnsPartnersId = 'partners';

export const columnsPartners = (headerPackage) => {
    return ([
        generateColumnDefByField({
            field: partnersFields.UUID,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: partnersFields.LEGAL_NAME,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: partnersFields.REGISTRATION_NUMBER,
            headerPackage: headerPackage
        }),
        generateColumnDefByField({
            field: partnersFields.CONNECTION_POINTS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                if (cell && cell.getValue()) {
                    const portsList = cell.getValue().map(element => element.port).join(' - ');
                    return (portsList && <div title={portsList}>{portsList}</div>);
                }
                return null;
            }
        })
    ]);
};